import { createSlice } from '@reduxjs/toolkit'

/**
 * Redux slice, que maneja las acciones que modifican
 * el estado de los usuarios.
 */
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    usuario: {},
    cargando: false,
    verificando: true
  },
  reducers: {
    /**
     * Acción que inicia el estado de carga de la autenticación.
     * @param {Object} state - Estado actual del slice.
     */
    loadAuthStart: (state) => {
      state.cargando = true
    },
    /**
     * Acción que finaliza el estado de carga de la autenticación.
     * @param {Object} state - Estado actual del slice.
     */
    loadAuthFinish: (state) => {
      state.cargando = false
    },
    /**
     * Acción que inicia el estado de verificación de la autenticación.
     * @param {Object} state - Estado actual del slice.
     */
    checkAuthStart: (state) => {
      state.verificando = true
    },
    /**
     * Acción que finaliza el estado de verificación de la autenticación.
     * @param {Object} state - Estado actual del slice.
     */
    checkAuthFinish: (state) => {
      state.verificando = false
    },
    /**
     * Acción que inicia sesión en la aplicación.
     * @param {Object} state - Estado actual del slice.
     * @param {Object} payload - Payload que contiene el usuario autenticado.
     */
    login: (state, { payload }) => {
      state.usuario = payload
    },
    /**
     * Acción que cierra sesión en la aplicación y finaliza el estado de carga.
     * @param {Object} state - Estado actual del slice.
     */
    logout: (state) => {
      state.usuario = {}
      state.cargando = false
      state.verificando = false
    }
  }
})

export const { loadAuthStart, loadAuthFinish, checkAuthStart, checkAuthFinish, login, logout } =
  authSlice.actions
export default authSlice.reducer
